import { useMemo } from 'react';
import {
    ZHLPersonalizedNextStepExperience,
    ZHLPersonalizedNextStepState,
} from 'src/services/graphql/generated/graphql';
import { isFirstPartyEligible } from 'src/experiences/CallbackScheduler/utils/isFirstPartyEligible';

export const useFirstPartyEligibility = (
    status: ZHLPersonalizedNextStepState | undefined | null,
    currentExperience: ZHLPersonalizedNextStepExperience | undefined | null
) => {
    const isFirstPartyExperience = useMemo(
        () => !!status && !!currentExperience && isFirstPartyEligible(status, currentExperience),
        [status, currentExperience]
    );

    return {
        isFirstPartyExperience,
    };
};
